export const MOBILELANDSCAPEOVERLAY_CONTENT = {
  overlayMessage: 'Please rotate your device to portrait mode for optimal experience',
}
